<div class="container-fluid">
  <div class="row mb-3">

    <div class="card shadow-sm p-0">
      <div class="card-header">
        <h3 class="card-title">{{ testlistId ? 'Update Testlist' : 'Create Testlist' }} </h3>
      </div>
      <div class="card-body">
        <settings-projects-testlist-form [testlist]="testlist" (onSavedData)="onProjectFormSavedData($event)"
          (onFieldChange)="onFieldChange($event)" />
      </div>
    </div>
  </div>

  <div class="row mb-3">
    <div class="card shadow-sm">
      <div class="card-header">
        <h3 class="card-title">Add Regulations to Testlist</h3>
      </div>
      <div class="card-body">
        <settings-regulation-to-new-testlist [jurisdictionId]="jurisdictionId" [lawId]="lawId"
          [checklistId]="checklistId" [testlist]="testlist" [formFieldsComplete]="formFieldsComplete" 
          (onSavedData)="onRegulationsToTestlistSavedData($event)" />
      </div>
    </div>
  </div>
</div>